/*
 * 使用MaterialModal 步骤
 * 1. 设置Modal宽度
 * 2. 设置Modal className
 * 3. 设置Modal的visible属性---根据某个状态显示或隐藏modal
 * 4. 设置是否有footer---没有用foot={null}
 * 5. buttonText=""---设置是否有footer中的button的文字内容
 * 6. action={() => this.updateData(userInfo.id, dataSingle.id)}---点击footer内Button触发的方法
 * 7. 拷贝所需的import的文件
 * 8. 拷贝所需的closeModal方法的文件
 */

 /* 使用请从这里复制并修改
   import closeIcon from "app/styles/images/sp/close.svg"

   closeModal = (modal) => {
     this.setState({
       [modal]: false
     })
   }

   <MaterialModal
     className="create-group-modal"
     title="新建报告组"
     visible={this.state.visible}
     width={960}
     buttonText="confirm"
     action={() => this.updateData(userInfo.id, dataSingle.id)}
   >
     <img
       className="pgx-modal-close"
       src={closeIcon}
       alt="关闭对话框"
       onClick={()=>this.closeModal("showCreateNewGroup")}
     />
   </MaterialModal>
 */

import React, { PropTypes } from "react"
import { Row, Modal } from "antd"
import titleIcon from "app/styles/images/sp/title.svg"
import "./Index.scss"
import cx from "classnames"

const styles = {
  primary: "primary-btn",
  danger: "danger-btn"
}
export default function MaterialModal (props) {
  const { title, buttonText, buttonType, action, className, ...rest } = props
  const ModalClass = cx({
    "pgx-modal": true,
    [className]: className
  })
  return (
    <Modal className={ModalClass}
      title={(
        <Row  className="pgx-modal-title" type="flex" justify="center" align="middle" >
          <img src={titleIcon} alt="" />
          <div className="content">{props.title}</div>
          <img src={titleIcon} alt="" />
        </Row>
      )}
      footer={(
        <Row type="flex" justify="center" align="middle">
          <button className={styles[buttonType]} onClick={action}>{buttonText}</button>
        </Row>
      )}
      {...rest}
    >
      {props.children}
    </Modal>
  )
}

MaterialModal.propTypes = {
  title: PropTypes.string,
  buttonText: PropTypes.string,
  buttonType: PropTypes.oneOf(["primary", "danger"])
}

MaterialModal.defaultProps = {
  buttonType: "primary",
  buttonText: "确定"
}



// WEBPACK FOOTER //
// ./src/app/components/normal/MaterialModal/index.js